import { COMPONENT_TYPES, FAQ } from '../../../constants';
import FAQComponent from './FAQ.component';
import FAQEditor from './FAQ.editor';
import FAQProperties from './FAQ.properties';
import { registerComponent } from '../registry';

// 레지스트리에 FAQ 컴포넌트 등록
registerComponent({
  type: COMPONENT_TYPES.FAQ,
  component: FAQComponent,
  editorComponent: FAQEditor,
  properties: FAQProperties,
  defaultProps: {
    title: '자주하는질문',
    faqItems: [
      { question: '질문 1', answer: '답변 1' },
      { question: '질문 2', answer: '답변 2' },
    ],
    style: {
      width: '100%',
      fontFamily: 'Arial, sans-serif',
    },
    titleStyle: {
      fontSize: '24px',
      fontWeight: 'bold',
      marginBottom: '20px',
      textAlign: 'left',
      color: '#333',
    }
  },
  category: 'content',
  icon: '❓',
  name: '자주하는질문'
});

// FAQ 컴포넌트 및 타입 내보내기
export { default as FAQComponent } from './FAQ.component';
export { default as FAQEditor } from './FAQ.editor';
export { default as FAQProperties } from './FAQ.properties';
export * from './FAQ.types'; 